module.exports = __webpack_public_path__ + "static/media/stroller.13a2391a.png";